import React from "react";
import Footer from "../Footer";

function Motivasi() {
  return (
    <div className="text-xl" data-aos="zoom-up">
      <h1 className="text-2xl md:text-3xl font font-semibold mb-2 dark:text-gray-200">
        Motivasi Belajar
      </h1>
      <hr className="border-2 borderd-slate-700 w-1/2 mt-10" />
      <p className="text-lg md:text-xl my-4 dark:text-gray-200">
        <b>``</b>kehidupan yang terus memaksa diri ini keras kepadanya,
        <br />
        ditata disiapkan dan diperjuangkan sehingga terlihat menawan,
        <br /> orang melihatput tak akan bosan, walau itu bukan tujuan,
        <br /> ketika melihat diri ini berjalan, maka terus tambah wawasan dan
        keterampilan,
        <br /> ketika beda jalan pun tidak akan ada yang dirugikan,
        <br /> justru disana terbuka banyak kesempatan,
        <br /> kesempatan untuk semua harapan dan impian<b>``</b>
        <br />
        <br /> Jadi apa yang kau tunggu? waktu?
        <br /> untuk apa menunggu waktu?
        <br /> menunggu ilmu datang padamu?
        <br /> menunggu kesuksesan menghampirimu?
        <br /> ketika kamu menunggu,
        <br /> impian hanya akan jadi impian
        <br /> ketika kamu menunggu,
        <br /> harapan hanya akan jadi harapan
        <br /> kamu hanya perlu melangkah dan terus berprogres
        <br />
        <br />{" "}
        <p className="font-semibold text-lg md:text-2xl mb-2">
          ويجزيهم اجرهم باحسن الذي كانوا يعملون{" "}
        </p>
        <p className=" mb-4 text-base">
          "Allah akan membalasi dan memberi upah mereka dengan yang terbaik dari
          apa yang mereka amalkan (kerjakan)" (Qs az-Zumar ayat 35)
        </p>
        <p className="font-semibold text-lg md:text-2xl mb-2">
          ا ن الله لا يغيـروا ما بـقوم حتى يغيـر ما بـانفسـهم . سورة الـرعـد اية
        </p>
        <p className=" text-base">
          "Sesungguhnya Allah tidak akan merobah keadaan suatu kaum selama kaum
          itu belum berusaha untuk merobahnya" (Qs ar-Ra’d ayat 12)
        </p>
      </p>
      <Footer />
    </div>
  );
}

export default Motivasi;
